export default __webpack_public_path__ + "static/media/sticker-W.d4e53dfd.png";